import { useEffect, useState } from "react";
import API from "../../../services/api";
import "./invoice-settings.css";

export default function InvoiceSettings() {
  const school = JSON.parse(localStorage.getItem("schoolAdmin"));

  const [showEdit, setShowEdit] = useState(false);
  const [isCreated, setIsCreated] = useState(false); // 🔥 detect create/edit mode

  const [form, setForm] = useState({
    school_name: "",
    tagline: "",
    terms: "",
    account_number: "",
    account_name: "",
    bank_name: "",
    logo: null,
    signature: null,
  });

  const [logo, setLogo] = useState(null);
  const [signature, setSignature] = useState(null);

  useEffect(() => {
    loadSettings();
  }, []);

  // =========================
  // FIX IMAGE URL
  // =========================
  const makeMediaUrl = (path) => {
    if (!path) return "";
    if (path.startsWith("http")) return path;

    const base =
      API.defaults.baseURL?.replace(/\/api\/?$/, "") ||
      "http://127.0.0.1:8000";

    return path.startsWith("/") ? `${base}${path}` : `${base}/${path}`;
  };

  // =========================
  // LOAD SETTINGS
  // =========================
  const loadSettings = async () => {
    try {
      const res = await API.get("/school-admin/invoice-setting/", {
        headers: { "X-SCHOOL-ID": school.school.id },
      });

      setForm(res.data);

      // 🔥 check if already created
      if (res.data.school_name || res.data.logo) {
        setIsCreated(true);
      }
    } catch (err) {
      console.log("No settings yet");
      setIsCreated(false);
    }
  };

  // =========================
  // HANDLE CHANGE
  // =========================
  const handleChange = (e) => {
    setForm((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  // =========================
  // SAVE
  // =========================
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const data = new FormData();

      Object.keys(form).forEach((key) => {
        if (form[key]) data.append(key, form[key]);
      });

      if (logo) data.append("logo", logo);
      if (signature) data.append("signature", signature);

      await API.post("/school-admin/invoice-setting/update/", data, {
        headers: {
          "Content-Type": "multipart/form-data",
          "X-SCHOOL-ID": school.school.id,
        },
      });

      alert("✅ Saved successfully!");

      setShowEdit(false);
      setLogo(null);
      setSignature(null);

      loadSettings();
    } catch {
      alert("❌ Save failed");
    }
  };

  return (
    <div className="invoice-page invoice-settings-page">

      {/* =========================
          🔥 HEADER
      ========================= */}
      <div className="invoice-header">
        <h2>Invoice Settings</h2>

        <button
          className="main-btn"
          onClick={() => setShowEdit(true)}
        >
          {isCreated ? "✏️ Edit Settings" : "➕ Create Settings"}
        </button>
      </div>

      {/* =========================
          🔥 PREVIEW CARD
      ========================= */}
      {isCreated && (
        <div className="preview-box premium">

          <div className="preview-top">
            {form.logo ? (
              <img
                src={makeMediaUrl(form.logo)}
                className="logo"
                alt=""
              />
            ) : (
              <div className="logo-placeholder">LOGO</div>
            )}

            <div>
              <h3>{form.school_name}</h3>
              <p>{form.tagline}</p>
            </div>
          </div>

          <div className="divider" />

          <div className="bank-section">
            <h4>Bank Details</h4>
            <p><b>Account No:</b> {form.account_number || "-"}</p>
            <p><b>Name:</b> {form.account_name || "-"}</p>
            <p><b>Bank:</b> {form.bank_name || "-"}</p>
          </div>

          <div className="divider" />

          <div className="terms-section">
            <h4>Terms</h4>
            <p>{form.terms || "-"}</p>
          </div>

          <div className="divider" />

          <div className="signature-section">
            {form.signature ? (
              <>
                <img
                  src={makeMediaUrl(form.signature)}
                  className="signature"
                  alt=""
                />
                <p>Authorized Signature</p>
              </>
            ) : (
              <p>No signature added</p>
            )}
          </div>

        </div>
      )}

      {!isCreated && (
        <div className="preview-box premium invoice-empty-state">
          <div className="empty-icon">₹</div>
          <h3>No invoice settings yet</h3>
          <p>
            Add school branding, bank details, terms, and signature before
            generating polished fee invoices.
          </p>
          <button className="main-btn" onClick={() => setShowEdit(true)}>
            Create Settings
          </button>
        </div>
      )}

      {/* =========================
          🔥 MODAL FORM
      ========================= */}
      {showEdit && (
        <div className="modal">
          <div className="modal-box premium-form">

            <h3>{isCreated ? "Edit Settings" : "Create Settings"}</h3>

            <form onSubmit={handleSubmit}>

              <input
                placeholder="School Name"
                name="school_name"
                value={form.school_name}
                onChange={handleChange}
              />

              <input
                placeholder="Tagline"
                name="tagline"
                value={form.tagline}
                onChange={handleChange}
              />

              <label>Upload Logo</label>
              <input type="file" onChange={(e)=>setLogo(e.target.files[0])}/>

              <label>Upload Signature</label>
              <input type="file" onChange={(e)=>setSignature(e.target.files[0])}/>

              <input
                placeholder="Account Number"
                name="account_number"
                value={form.account_number}
                onChange={handleChange}
              />

              <input
                placeholder="Account Name"
                name="account_name"
                value={form.account_name}
                onChange={handleChange}
              />

              <input
                placeholder="Bank Name"
                name="bank_name"
                value={form.bank_name}
                onChange={handleChange}
              />

              <textarea
                placeholder="Terms & Conditions"
                name="terms"
                value={form.terms}
                onChange={handleChange}
              />

              <div className="form-actions">
                <button type="submit" className="save-btn">
                  Save
                </button>

                <button
                  type="button"
                  className="cancel-btn"
                  onClick={()=>setShowEdit(false)}
                >
                  Cancel
                </button>
              </div>

            </form>

          </div>
        </div>
      )}

    </div>
  );
}
